"use strict";

exports.__esModule = true;
exports.SelectorOption = SelectorOption;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function SelectorOption(props) {
  var value = props.value,
    parentComponent = props.parentComponent;
  if (!value) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("span", {
    "data-testid": parentComponent + "." + value
  }, value);
}